import Download from '@/assets/icons/download.svg?component';
import { Button } from '@/components/atoms/Buttons';
import { Spinner } from '@/components/atoms/Spinner';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import ExportDataDropDown from '@/components/molecules/ExportDataDropDown';

import { useBehaviorExport } from '../hooks/useBehaviorExport';

export interface BehaviorExportButtonProps {
    cageId: number;
    disabled?: boolean;
}

/**
 * The shared Export panel, with buttons that fetch the last 30 days on click instead of
 * exporting rows the page already holds, so DownloadOptions does not fit.
 */
export default function BehaviorExportButton({
    cageId,
    disabled = false,
}: BehaviorExportButtonProps) {
    const { isExporting, exportCSV, exportXLSX } = useBehaviorExport(cageId);

    const icon = isExporting ? (
        <Spinner />
    ) : (
        <SvgIcon icon={Download} size="custom" customSize={20} />
    );

    return (
        <ExportDataDropDown disabled={disabled}>
            <Button
                size="medium"
                variant="secondary"
                trackingId="behavior_export_csv"
                onClick={exportCSV}
                disabled={isExporting}
                icon={icon}>
                CSV
            </Button>
            <Button
                size="medium"
                variant="secondary"
                trackingId="behavior_export_xlsx"
                onClick={exportXLSX}
                disabled={isExporting}
                icon={icon}>
                XLSX
            </Button>
        </ExportDataDropDown>
    );
}
